import { render, staticRenderFns } from "./FrequencyLoginUserChart.vue?vue&type=template&id=5b18376a&scoped=true&"
import script from "./FrequencyLoginUserChart.vue?vue&type=script&lang=js&"
export * from "./FrequencyLoginUserChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b18376a",
  null
  
)

export default component.exports